import { adminDashboard_actionType } from "../../actionTypes/adminAction-actionTypes/adminDashboard-actionType";

const initialState = {
  requestsCount: 0,
  curPage: 1,
  pageSize: 50,
  changeType: "page",
  searchText: "",
  responseStore: [],
  requests: [],
  filterQuery: [],
  active_users: {
    lilly_users: 0,
    non_lilly_users: 0,
    total_count: 0
  },
  inactive_users: {
    lilly_users: 0,
    non_lilly_users: 0,
    total_count: 0
  },
  total_requests: {
    account_creations: 0,
    account_modifications: 0,
    total_count: 0
  },
  ageing_request: 0,
  test: null
};

const AdminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminDashboard_actionType.RESET_DASHBOARD_SUCCESS:
      return state;
    case adminDashboard_actionType.GET_DASHBOARD_SUCCESS:
      return {
        ...state,
        requests: action.data,
        responseStore: action.responseStore,
        filterQuery: action.filterQuery,
        requestsCount: action.requestsCount
      };
    case adminDashboard_actionType.GET_DASHBOARD_FAILURE:
      return {
        ...state,
        error: action.data
      };
    case adminDashboard_actionType.GET_ADMIN_REQUEST_DETAIL_SUCCESS:
      return {
        ...state,
        active_users: action.data?.data?.active_users,
        ageing_request: action.data?.data?.ageing_request,
        inactive_users: action.data?.data?.inactive_users,
        total_requests: action.data?.data?.total_requests
      };
      case adminDashboard_actionType.SET_PAGE:
      return {
        ...state,
        curPage: action.value || state.curPage,
        changeType: "page"
      };
      case adminDashboard_actionType.SET_DASHBOARD_FILTERS:
      return {
        ...state,
        filterQuery: action.data || state.filterQuery,
        changeType: "filter"
      };
      case adminDashboard_actionType.SET_REQUEST_COUNT:
      return {
        ...state,
        requestsCount: action.value
      };
      case adminDashboard_actionType.SET_DASHBOARD_SEARCH:
        return {
          ...state,
          searchText: action.data,
          changeType: "search"
        };
    default:
      return state;
  }
};

export default AdminDashboardReducer;